import config from 'config'
import URL from 'url-parse'
import moment from 'moment'
import request from '@/modules/base/util/request'
import { isObsoleteEmailConfirmationNotification } from '@/modules/base/components/notification/isObsoleteEmailConfirmationNotification'

/*
 * Actions
 */
const START_FETCHING_NEWSFEED_DATA = 'orgamax/newsfeed/START_FETCHING_NEWSFEED_DATA'
const START_FETCHING_NEWSFEED_COUNT_DATA = 'orgamax/newsfeed/START_FETCHING_NEWSFEED_COUNT_DATA'
const FINISHED_FETCHING_NEWSFEED_DATA = 'orgamax/newsfeed/FINISHED_FETCHING_NEWSFEED_DATA'
const FINISHED_FETCHING_NEWSFEED_COUNT_DATA = 'orgamax/newsfeed/FINISHED_FETCHING_NEWSFEED_COUNT_DATA'
const ERROR_FETCHING_NEWSFEED_DATA = 'orgamax/newsfeed/ERROR_FETCHING_NEWSFEED_DATA'
const ERROR_FETCHING_NEWSFEED_COUNT_DATA = 'orgamax/newsfeed/ERROR_FETCHING_NEWSFEED_COUNT_DATA'
const MARK_AS_READ = 'orgamax/newsfeed/MARK_AS_READ'
const PREPEND_NEWS = 'orgamax/newsfeed/PREPEND_NEWS'
const MARK_ALL_AS_READ = 'orgamax/newsfeed/MARK_ALL_AS_READ'

/*
 * Reducer
 */
const initialState = {
  isCountLoading: true,
  isLoading: true,
  countErrorOccurred: false,
  errorOccurred: false,
  items: [],
  unreadCount: -1,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_FETCHING_NEWSFEED_DATA:
      return { ...state, isLoading: true }
    case START_FETCHING_NEWSFEED_COUNT_DATA:
      return { ...state, isCountLoading: true }
    case FINISHED_FETCHING_NEWSFEED_DATA: {
      const { items } = action

      return {
        ...state,
        isLoading: false,
        errorOccurred: false,
        items,
      }
    }
    case FINISHED_FETCHING_NEWSFEED_COUNT_DATA:
      const { unreadCount } = action

      return {
        ...state,
        isCountLoading: false,
        countErrorOccurred: false,
        unreadCount,
      }
    case ERROR_FETCHING_NEWSFEED_DATA:
      return {
        ...state,
        isLoading: false,
        errorOccurred: true,
      }
    case ERROR_FETCHING_NEWSFEED_COUNT_DATA:
      return {
        ...state,
        isCountLoading: false,
        countErrorOccurred: true,
      }
    case MARK_AS_READ: {
      const { id, readDate } = action
      const { items } = state

      const pos = items.map(i => i.id).indexOf(id)
      items[pos].readDate = readDate

      return {
        ...state,
        items,
      }
    }
    case PREPEND_NEWS:
      const { item, count } = action

      return {
        ...state,
        items: [
          item,
          ...state.items,
        ].slice(0, 100),
        unreadCount: count,
      }
    case MARK_ALL_AS_READ:
      const { readDate } = action
      const { items } = state

      return {
        ...state,
        items: items.map(i => ({ ...i, readDate })),
        unreadCount: 0,
      }

    default:
      return state
  }
};
;

/*
 * Action Creators
 */
const startFetchingNewsfeedData = () => {
  return {
    type: START_FETCHING_NEWSFEED_DATA,
  }
}

const startFetchingNewsfeedCountData = () => {
  return {
    type: START_FETCHING_NEWSFEED_COUNT_DATA,
  }
}

const finishedFetchingNewsfeedData = ({ items, unreadCount }) => {
  return {
    type: FINISHED_FETCHING_NEWSFEED_DATA,
    items,
    unreadCount,
  }
}

export const finishedFetchingNewsfeedCountData = ({ unreadCount }) => {
  return {
    type: FINISHED_FETCHING_NEWSFEED_COUNT_DATA,
    unreadCount,
  }
}

const errorFetchingNewsfeedData = () => {
  return {
    type: ERROR_FETCHING_NEWSFEED_DATA,
  }
}

const errorFetchingNewsfeedCountData = () => {
  return {
    type: ERROR_FETCHING_NEWSFEED_COUNT_DATA,
  }
}

const markedAsRead = ({ id, readDate }) => {
  return {
    type: MARK_AS_READ,
    id,
    readDate,
  }
}

const markedAllAsRead = ({ readDate }) => {
  return {
    type: MARK_ALL_AS_READ,
    readDate,
  }
}

export const fetchNewsfeedCount = () => {
  return async(dispatch) => {
    dispatch(startFetchingNewsfeedCountData())

    try {
      const { body: { data: { count } } } = await request(`${config.resourceHost}notification/count`, { auth: true, isConcurrent: true, skipLogout: true })
      dispatch(finishedFetchingNewsfeedCountData({
        unreadCount: count,
      }))
    } catch (e) {
      dispatch(errorFetchingNewsfeedCountData())
    }
  }
}

export const fetchNewsfeedData = () => {
  return async(dispatch) => {
    dispatch(startFetchingNewsfeedData())

    try {
      const { body: { data: { notifications } } } = await request(`${config.resourceHost}notification`, {
        auth: true, isConcurrent: true, skipLogout: true,
      })

      dispatch(finishedFetchingNewsfeedData({
        items: notifications
          // DO-13064: a confirmed address needs no "verify your e-mail" reminder any more
          .filter((notification) => !isObsoleteEmailConfirmationNotification(notification))
          .map((notification) => {
            if (notification.link) {
              const urlObj = URL(notification.link)
              notification.link = `${urlObj.pathname}${urlObj.hash || ''}`
            }

            return notification
          }),
      }))
    } catch (e) {
      dispatch(errorFetchingNewsfeedData())
    }
  }
}

export const markAsRead = id => {
  return async(dispatch) => {
    const response = await request(`${config.resourceHost}notification/${id}/read`, {
      auth: true, isConcurrent: true, method: 'PUT',
    })

    dispatch(markedAsRead({ id, readDate: response?.body?.data?.readDate || moment().toJSON() }))
  }
}

export const prependNews = item => {
  return async(dispatch) => {
    const { body: { data: { count } } } = await request(`${config.resourceHost}notification/count`, { auth: true, isConcurrent: true, skipLogout: true })
    dispatch({
      type: PREPEND_NEWS,
      item,
      count,
    })
  }
}

export const markAllAsRead = () =>
  async(dispatch) => {
    const response = await request(`${config.resourceHost}notification/read/all`, { auth: true, isConcurrent: true, method: 'PUT' })

    dispatch(markedAllAsRead({ readDate: response?.body?.data?.readDate || moment().toJSON() }))
  }
